import { gql } from '@apollo/client';

export const UPDATE_NOTE_CLASSE = gql`
  mutation UpdateNoteClasse {
    updateNoteClasse
  }
`;
